import React from 'react';
import { galleryImages } from '../utils/mock';

const Gallery = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Gallery of <span className="text-cyan-400">Workshop</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Glimpses from our AI, Robotics, and IoT training workshops with students and our Robotics projects that you can enroll and learn how to build from scratch
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {galleryImages.map((image) => (
              <div
                key={image.id}
                className="group relative bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950/50 backdrop-blur-sm border border-cyan-500/20 rounded-xl overflow-hidden hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20"
              >
                {/* Actual Workshop Image */}
                <div className="w-full h-80 flex items-center justify-center bg-slate-950/50 p-4">
                  <img 
                    src={image.image} 
                    alt={image.title}
                    className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/95 via-slate-950/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <h3 className="text-white font-semibold text-lg mb-2">{image.title}</h3>
                  <p className="text-gray-300 text-sm mb-2">{image.description}</p>
                  <p className="text-cyan-400 text-xs uppercase tracking-wider">{image.category}</p>
                </div>

                {/* Bottom Info Bar (Always Visible) */}
                <div className="bg-slate-950/80 backdrop-blur-sm p-4 group-hover:opacity-0 transition-opacity duration-300">
                  <h3 className="text-white font-semibold text-sm">{image.title}</h3>
                </div>
              </div>
            ))}
          </div>

          {/* Info Message */}
          <div className="mt-16 text-center">
            <div className="inline-block bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950/50 backdrop-blur-sm border border-cyan-500/20 rounded-xl p-8">
              <p className="text-gray-400 text-lg">
                More workshop photos coming soon! Follow us on social media for regular updates.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
